<template>
  <td
    data-label="Sort order"
  >
    <p>{{ title }}</p>
  </td>
</template>

<script>
  export default {
    name: 'TdSortOrder',
    props: [
      'title'
    ]
  }
</script>
